import $ from "/srv/www/z/zeilmakerijdevriesmaritiem.nl/vhosts/www/htdocs/content/mu-plugins/wp-soup-plugin/node_modules/jquery";

$(document).ready(function() {
    // Funnel
    const funnelPartList = $(".funnel-onderdeel ul");
    const firstFunnelPart = funnelPartList.children("li:nth-child(1)");
    const firstFunnelPartInput = funnelPartList
        .children("li:nth-child(1)")
        .children("input");
    const secondFunnelPart = funnelPartList.children("li:nth-child(2)");
    const secondFunnelPartInput = funnelPartList
        .children("li:nth-child(2)")
        .children("input");
    const funnelPartHelp = funnelPartList.children("li:last-child");
    const funnelPartHelpInput = funnelPartHelp.children("input");

    const comments = $(".funnel-opmerkingen");
    const upload = $(".funnel-upload");
    const personalData = $("[class*='funnel-persoon-']");
    const footer = $(".funnel-form .gform_footer");

    // Initially hide fields.
    comments.hide();
    upload.hide();
    personalData.each(function() {
        $(this).hide();
    });
    footer.hide();

    function scrollIntoView(element) {
        var interval = setInterval(function() {
            const el = $(element).offset().top;
            if (el > 0) {
                $("html, body").animate(
                    {
                        scrollTop: el - 300
                    },
                    500
                );
                clearInterval(interval);
            }
        }, 1);
    }

    $(".funnel-form").change(function() {
        if (!$(".funnel-omschrijving li:last-child input:checked").length > 0) {
            if (
                $(".funnel-onderdeel-zeilen input:checked").length > 0 ||
                $(".funnel-onderdeel-tuigerij input:checked").length > 0 ||
                $(".funnel-onderdeel-boottent input:checked").length > 0 ||
                $(".funnel-onderdeel-reparatie input:checked").length > 0 ||
                $(".funnel-onderdeel-overige input:checked").length > 0 ||
                funnelPartHelpInput.is(":checked")
            ) {
                scrollIntoView(".funnel-opmerkingen");
                comments.show();
                upload.show();
                personalData.each(function() {
                    $(this).show();
                });
                footer.show();
            } else {
                comments.hide();
                upload.hide();
                personalData.each(function() {
                    $(this).hide();
                });
                footer.hide();
            }
        }
    });

    $(".funnel-omschrijving li").change(function() {
        const index = $(this).index();
        if (index === 1) {
            // Show checkbox if the second checkbox has been selected.
            funnelPartHelp.show();
        } else {
            if (funnelPartHelpInput.is(":checked")) {
                funnelPartHelpInput.trigger("click");
            }
            // Hide checkbox.
            funnelPartHelp.hide();
        }

        if (index === 2) {
            scrollIntoView(".funnel-schip");
        } else {
            scrollIntoView(".funnel-type-schip");
        }

        // Hide on selecting a new description.
        comments.hide();
        upload.hide();
        personalData.each(function() {
            $(this).hide();
        });
        footer.hide();
    });

    $(".funnel-schip li").change(function() {
        const index = $(this).index();
        if (index === 1) {
            // Show personal data if the second radio button has been selected.
            comments.show();
            upload.show();
            personalData.each(function() {
                $(this).show();
            });
            footer.show();
            scrollIntoView(".funnel-opmerkingen");
        } else {
            comments.hide();
            upload.hide();
            personalData.each(function() {
                $(this).hide();
            });
            footer.hide();
            scrollIntoView(".funnel-type-schip");
        }
    });

    $(".funnel-type-schip select").change(function() {
        if (this.selectedIndex === 1 || this.selectedIndex === 2) {
            // Show checkboxes if the first or second checkbox has been selected.
            firstFunnelPart.show();
            secondFunnelPart.show();
            scrollIntoView(".funnel-lengte-schip");
        } else {
            // Uncheck checkboxes if checked.
            if (firstFunnelPartInput.is(":checked")) {
                firstFunnelPartInput.trigger("click");
            }
            if (secondFunnelPartInput.is(":checked")) {
                secondFunnelPartInput.trigger("click");
            }

            // Hide checkboxes.
            firstFunnelPart.hide();
            secondFunnelPart.hide();
        }
    });

    $(".funnel-lengte-schip select").change(function() {
        scrollIntoView(".funnel-onderdeel");
        if (
            $(".funnel-omschrijving li:last-child input:checked").length > 0 &&
            this.selectedIndex !== 0
        ) {
            comments.show();
            upload.show();
            personalData.each(function() {
                $(this).show();
            });
            footer.show();
        } else {
            comments.hide();
            upload.hide();
            personalData.each(function() {
                $(this).hide();
            });
            footer.hide();
        }
    });

    $(".submit-button-1").on("click", function() {
        document.querySelectorAll(".gfield.gform_hidden input")[0].value =
            "Contact";
    });

    $(".submit-button-2").on("click", function() {
        document.querySelectorAll(".gfield.gform_hidden input")[0].value =
            "Offerte";
    });
});
